import { render, staticRenderFns } from "./SideMessage.vue?vue&type=template&id=4da1e027&"
import script from "./SideMessage.vue?vue&type=script&lang=js&"
export * from "./SideMessage.vue?vue&type=script&lang=js&"
import style0 from "./SideMessage.vue?vue&type=style&index=0&id=4da1e027&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports